(function(){
  if (window.brfWl) return;
  var KEY = 'brf-wl', MAX = 100, doc = document;
  var PAGE = '/pages/wishlist';
  var HEART = 'M12 20.6s-7.6-4.6-9.3-9.4C1.6 8 3.5 4.6 7 4.6c2 0 3.6 1.1 5 3 1.4-1.9 3-3 5-3 3.5 0 5.4 3.4 4.3 6.6-1.7 4.8-9.3 9.4-9.3 9.4z';
  var HDR = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M12 20.2s-7.1-4.3-8.5-8.8C2.6 8.6 4.4 5.2 7.4 5.2c1.9 0 3.4 1 4.6 2.8 1.2-1.8 2.7-2.8 4.6-2.8 3 0 4.8 3.4 3.9 6.2-1.4 4.5-8.5 8.8-8.5 8.8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function svgHeart(){ return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + HEART + '"/></svg>'; }

  function load(){ try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter(function(h){ return typeof h === 'string' && h; }) : []; } catch (e) { return []; } }
  var list = load();
  function save(){ try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {} }
  function has(h){ return list.indexOf(h) > -1; }
  function add(h){ if (!has(h)) { list.unshift(h); save(); } }
  function remove(h){ var i = list.indexOf(h); if (i > -1) { list.splice(i, 1); save(); } }
  function handleOf(href){ var m = /\/products\/([^\/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : ''; }

  /* ---------- toast ---------- */
  var toast, toastT;
  function say(html, href){
    if (!toast) { toast = doc.createElement('a'); toast.className = 'brf-wl-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite'); doc.body.appendChild(toast); }
    if (!toast.brfBound) { toast.brfBound = 1; toast.addEventListener('click', function(e){ var u = toast.getAttribute('data-undo'); if (!u) return; e.preventDefault(); add(u); toast.removeAttribute('data-undo'); paint(); say('<i class="brf-wl-toast__ic is-on" aria-hidden="true">' + svgHeart() + '</i><span>Back in your wishlist</span><b>View</b>'); }); }
    toast.removeAttribute('data-undo');
    toast.innerHTML = html; toast.href = href || PAGE;
    toast.classList.add('is-in'); clearTimeout(toastT);
    toastT = setTimeout(function(){ toast.classList.remove('is-in'); }, 2600);
  }

  /* ---------- hearts ---------- */
  function paint(){
    [].forEach.call(doc.querySelectorAll('.brf-wl-heart'), function(b){
      var on = has(b.getAttribute('data-h'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? 'Remove from wishlist: ' : 'Save to wishlist: ') + (b.getAttribute('data-t') || ''));
    });
    var n = list.length ? String(list.length) : '';
    [].forEach.call(doc.querySelectorAll('.brf-wl-hdr__n'), function(s){ if (s.textContent !== n) s.textContent = n; });
    [].forEach.call(doc.querySelectorAll('.brf-wl-hdr'), function(a){ a.setAttribute('aria-label', 'Wishlist' + (list.length ? ', ' + list.length + (list.length === 1 ? ' item' : ' items') : '')); });
  }
  function makeHeart(h, title, extra){
    var b = doc.createElement('button');
    b.type = 'button'; b.className = 'brf-wl-heart' + (extra ? ' ' + extra : '');
    b.setAttribute('data-h', h); b.setAttribute('data-t', title || '');
    b.innerHTML = svgHeart();
    return b;
  }
  doc.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.brf-wl-heart');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-h');
    if (has(h)) { remove(h); say('<i class="brf-wl-toast__ic" aria-hidden="true">' + svgHeart() + '</i><span>Removed from your wishlist</span><b>Undo</b>'); toast.setAttribute('data-undo', h); }
    else {
      add(h); say('<i class="brf-wl-toast__ic is-on" aria-hidden="true">' + svgHeart() + '</i><span>Saved to your wishlist</span><b>View</b>');
      b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
      [].forEach.call(doc.querySelectorAll('.brf-wl-hdr'), function(a){ a.classList.remove('is-pop'); void a.offsetWidth; a.classList.add('is-pop'); });
    }
    paint();
  }, true);

  function scan(){
    [].forEach.call(doc.querySelectorAll('.product-item .brf-pi-media'), function(m){
      if (m.querySelector(':scope > .brf-wl-heart')) return;
      var a = m.querySelector('a.product-item__image-wrapper'), h = a && handleOf(a.getAttribute('href'));
      if (!h) return;
      var card = m.closest('.product-item'), t = card && card.querySelector('.product-item__title');
      m.appendChild(makeHeart(h, t ? t.textContent.trim() : ''));
    });
    if (/\/products\//.test(location.pathname)) {
      var pm = doc.querySelector('.product-meta'), h1 = pm && pm.querySelector('h1.product-meta__title');
      if (h1 && !pm.querySelector(':scope > .brf-wl-heart')) {
        pm.classList.add('brf-wl-has');
        pm.insertBefore(makeHeart(handleOf(location.pathname), h1.textContent.trim(), 'brf-wl-heart--pdp'), pm.firstChild);
      }
    }
    var acc = doc.querySelector('.header__action-item--account');
    if (acc && !doc.querySelector('.header__action-item--wishlist')) {
      var d = doc.createElement('div'); d.className = 'header__action-item header__action-item--wishlist';
      d.innerHTML = '<a class="header__action-item-link brf-wl-hdr" href="' + PAGE + '">' + HDR + '<span class="brf-wl-hdr__n"></span></a>';
      acc.parentNode.insertBefore(d, acc);
    }
    var acts = doc.querySelector('.brf-hc__acts'), cart = acts && acts.querySelector('[data-brf-hc-cart]');
    if (cart && !acts.querySelector('.brf-wl-hdr')) {
      var a2 = doc.createElement('a'); a2.className = 'brf-hc__btn brf-wl-hdr'; a2.href = PAGE;
      a2.innerHTML = HDR + '<span class="brf-wl-hdr__n"></span>';
      acts.insertBefore(a2, cart);
    }
    paint();
  }
  var queued = false;
  function soon(){ if (queued) return; queued = true; (window.requestAnimationFrame || setTimeout)(function(){ queued = false; scan(); }); }
  window.addEventListener('storage', function(e){ if (e.key === KEY) { list = load(); paint(); if (pageBox) renderPage(); } });

  /* ---------- the wishlist page ---------- */
  var pageBox = null;
  function money(p){ return '£' + (p / 100).toFixed(2); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function img(u){ if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=500'; }
  var cache = {};
  function fetchP(h){
    if (cache[h]) return cache[h];
    return cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', {credentials: 'same-origin'}).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
  }
  function shared(){ var m = /[?&]items=([^&#]+)/.exec(location.search); return m ? decodeURIComponent(m[1]).split(',').filter(Boolean).slice(0, MAX) : null; }
  function cardHtml(p, mine){
    var v = p.variants || [], buyable = v.filter(function(x){ return x.available; });
    var one = v.length === 1 && buyable.length === 1;
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var price = (p.price_varies ? 'From ' : '') + money(p.price) + (sale ? ' <s>' + money(p.compare_at_price) + '</s>' : '');
    var btn = !p.available ? '<button class="brf-wl__btn" disabled>Sold out</button>'
      : one ? '<button class="brf-wl__btn" data-brf-wl-add="' + buyable[0].id + '">Add to bag</button>'
      : '<a class="brf-wl__btn brf-wl__btn--ghost" href="' + esc(p.url) + '">Choose options</a>';
    return '<div class="brf-wl__card" data-h="' + esc(p.handle) + '">' +
      (mine ? '<button class="brf-wl__x" data-brf-wl-x aria-label="Remove ' + esc(p.title) + ' from wishlist"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
            : '<button type="button" class="brf-wl-heart" data-h="' + esc(p.handle) + '" data-t="' + esc(p.title) + '" style="top:8px;bottom:auto;right:8px">' + svgHeart() + '</button>') +
      '<a class="brf-wl__img" href="' + esc(p.url) + '">' + (p.featured_image ? '<img loading="lazy" src="' + esc(img(p.featured_image)) + '" alt="' + esc(p.title) + '">' : '') + '</a>' +
      '<div class="brf-wl__info"><a class="brf-wl__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="brf-wl__price' + (sale ? ' is-sale' : '') + '">' + price + '</div>' +
      (p.available ? '' : '<div class="brf-wl__out">Sold out for now. We’ll keep it here for you.</div>') + btn + '</div></div>';
  }
  function emptyHtml(){
    return '<div class="brf-wl__empty"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' + HDR.replace(/^<svg[^>]*>/, '').replace('</svg>', '') + '</svg>' +
      '<h2>Nothing saved yet</h2><p>Tap the ♡ on any fabric or product and it’ll wait here for you. No rush, it won’t run off.</p>' +
      '<a class="brf-wl__btn" href="/collections/all">Start browsing</a></div>';
  }
  function renderPage(){
    var sh = shared(), mine = !sh, hs = sh || list;
    var head = '<div class="brf-wl__head"><div><h1 class="brf-wl__title">' + (mine ? 'My wishlist' : 'A wishlist shared with you') + '</h1>' +
      '<p class="brf-wl__sub" data-brf-wl-sub>' + (hs.length ? hs.length + (hs.length === 1 ? ' item' : ' items') : '') + '</p></div>' +
      (mine && hs.length ? '<button class="brf-wl__btn brf-wl__btn--ghost" data-brf-wl-share>Share list</button>' : '') + '</div>';
    var note = sh ? '<div class="brf-wl__shared"><span>Tap a heart to save any of these to your own wishlist.</span><a class="brf-wl__btn brf-wl__btn--ghost" href="' + PAGE + '">See my wishlist</a></div>' : '';
    if (!hs.length) { pageBox.innerHTML = head + emptyHtml(); return; }
    pageBox.innerHTML = head + note + '<div class="brf-wl__grid" data-brf-wl-grid></div>';
    var grid = pageBox.querySelector('[data-brf-wl-grid]'), want = hs.slice();
    Promise.all(want.map(fetchP)).then(function(ps){
      if (!pageBox.contains(grid)) return;
      var gone = [];
      grid.innerHTML = ps.map(function(p, i){ if (!p) { gone.push(want[i]); return ''; } return cardHtml(p, mine); }).join('');
      if (mine && gone.length) { gone.forEach(remove); paint(); }
      var shown = grid.children.length;
      var sub = pageBox.querySelector('[data-brf-wl-sub]'); if (sub) sub.textContent = shown + (shown === 1 ? ' item' : ' items');
      if (!shown) pageBox.innerHTML = head.replace(/<button[^>]*data-brf-wl-share[^>]*>[^<]*<\/button>/, '') + emptyHtml();
      paint();
    });
  }
  doc.addEventListener('click', function(e){
    if (!pageBox || !e.target.closest) return;
    var x = e.target.closest('[data-brf-wl-x]');
    if (x) {
      var card = x.closest('.brf-wl__card'), h = card.getAttribute('data-h');
      remove(h); paint(); card.classList.add('is-gone');
      setTimeout(function(){ renderPage(); }, 280);
      say('Removed from your wishlist');
      return;
    }
    var s = e.target.closest('[data-brf-wl-share]');
    if (s) {
      var url = location.origin + PAGE + '?items=' + encodeURIComponent(list.join(','));
      if (navigator.share) { navigator.share({title: 'My Bullring Fabrics wishlist', url: url}).catch(function(){}); return; }
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function(){ say('Link copied. Paste it anywhere to share your list.'); }, function(){ window.prompt('Copy this link to share your wishlist:', url); });
      return;
    }
    var ad = e.target.closest('[data-brf-wl-add]');
    if (ad && !ad.disabled) {
      ad.disabled = true; var was = ad.textContent; ad.textContent = 'Adding…';
      fetch('/cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: [{id: +ad.getAttribute('data-brf-wl-add'), quantity: 1}]})})
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
        .then(function(){
          ad.textContent = 'Added ✓';
          doc.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {scrollToTop: false}}));
          doc.dispatchEvent(new CustomEvent('brf:bag-added'));
          say('Added to your bag <b>View bag</b>', '/cart');
          setTimeout(function(){ ad.textContent = was; ad.disabled = false; }, 2200);
        }, function(err){
          ad.textContent = was; ad.disabled = false;
          say(esc((err && (err.description || err.message)) || 'Sorry, that couldn’t be added just now.'), location.href);
        });
    }
  });

  function boot(){
    pageBox = doc.getElementById('brf-wl-page');
    if (pageBox) renderPage();
    scan();
    if (window.MutationObserver) new MutationObserver(soon).observe(doc.body, {childList: true, subtree: true});
  }
  window.brfWl = {list: function(){ return list.slice(); }, add: function(h){ add(h); paint(); }, remove: function(h){ remove(h); paint(); }};
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
